import { render, staticRenderFns } from "./frequency.vue?vue&type=template&id=655d2b3b&scoped=true"
import script from "./frequency.vue?vue&type=script&lang=js"
export * from "./frequency.vue?vue&type=script&lang=js"
import style0 from "./frequency.vue?vue&type=style&index=0&id=655d2b3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655d2b3b",
  null
  
)

export default component.exports